"use strict";
/**
 * This type contains all data and meta-data of the given contact.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractMetadata = void 0;
class ContractMetadata {
}
exports.ContractMetadata = ContractMetadata;
//# sourceMappingURL=ContractDefinition.js.map